/**
 * Copyright (c) 2018-present clchart Contributors.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// 预先定义好的公式，比如MA等，可在这里扩展公式定义
// 用户可以自定义公式注册到ClData层，便于系统调用

import { getValue } from '../datas/cl.data'

/**
 * Class representing ClFormula
 * @export
 * @class ClFormula
 */
export class ClFormula {
    /**
     * Creates an instance of ClFormula.
     * @constructor
     */
    constructor() {
        this.source = {
            data: {},
            minIndex: 0,
            maxIndex: 0,
            nowIndex: 0
        }
    }
    /**
     * get value from data layer
     * @param {String} label
     * @param {Number} offIndex
     * @return {Array}
     * @memberof ClFormula
     */
    getValue(label, offIndex) { // offIndex 向前偏移offIndex条记录
        if (label === undefined) return 0
        if (this.source.data === undefined || this.source.data.value === undefined) return 0

        if (this.source.nowIndex === undefined) this.source.nowIndex = this.source.minIndex
        let index = this.source.nowIndex - offIndex
        index = index < 0 ? 0 : index
        return getValue(this.source.data, label, index)
    }
    /**
     * calculate single stock data by formula
     * @param {Object} source
     * @param {String} formula
     * @return {Array}
     * @memberof ClFormula
     */
    runSingleStock(source, formula) {
        // fix for Wechat mina do not support eval
        if (!eval) {
            const singleValue = []
            const matchData = formula.match(/\.(\w+)(\(.+)/)
            const funcName = matchData[1]
            if (typeof this[funcName] !== 'function') {
                return singleValue
            }
            let argStr = matchData[2] || ''
            argStr = argStr.replace(/\(|\)/g, '').split(',')
            this.source = source
            for (this.source.nowIndex = this.source.minIndex; this.source.nowIndex <= this.source.maxIndex; this.source.nowIndex++) {
                const out = this[funcName](...argStr)
                singleValue.push([this.getValue('index', 0), out])
            }
            return singleValue
        }
        const singleValue = []
        this.source = source
        // console.log(source);
        
        const command = `
    for (this.source.nowIndex = this.source.minIndex;this.source.nowIndex <= this.source.maxIndex;this.source.nowIndex++) {
          const ${formula}
          singleValue.push([this.getValue('index', 0), out]);
    }`
        eval(command)
        // console.log(singleValue);
        return singleValue
    }

    //  自定义公式

    /**
     * calculate move averge data
     * @param {String} label
     * @param {Number} period
     * @return {Array}
     * @memberof ClFormula
     */
    MA(label, period) {
        let off = 0
        let value = 0
        for (let m = 0; m < period; m++) {
            const v = this.getValue(label, m)
            if (v !== 0) {
                off++
                value += v
            }
        }
        
        return off === 0 ? 0 : value / off
    }
    MAAREA(label, period, grade) {
        let off = 0
        let value = 0
        for (let m = 0; m < period; m++) {
            const v = this.getValue(label, m)
            if (v !== 0) {
                off++
                value += v
            }
        }
        value = off === 0 ? 0 : value / off
        value *= (1.0 + Math.sign(grade) * Math.pow(2, Math.abs(grade) - 1) * 0.382 * 0.382)
        return value
    }
    AREA(label, grade) {
        let value = this.getValue(label, 0)
        value *= (1.0 + Math.sign(grade) * Math.pow(2, Math.abs(grade) - 1) * 0.382 * 0.382)
        return value
    }
    MAFBNQ(label, period, grade) {
        let off = 0
        let value = 0
        for (let m = 0; m < period; m++) {
            const v = this.getValue(label, m)
            if (v !== 0) {
                off++
                value += v
            }
        }
        value = off === 0 ? 0 : value / off
        value *= (1.0 + Math.sign(grade) * Math.pow(0.618, Math.abs(grade)))
        return value
    }
    FBNQ(label, grade) {
        let value = this.getValue(label, 0)
        value *= (1.0 + Math.sign(grade) * Math.pow(0.618, Math.abs(grade)))
        return value
    }
    SUMMA(label, sumday, madays) {
        // console.log('----');
        let mav = 0
        for (let s = 0; s < madays; s++) {
            let sumv = 0
            for (let m = s; m < s + sumday; m++) {
                sumv += this.getValue(label, m)
                // console.log(m, sumv, this.getValue(label, m));
            }
            sumv /= sumday
            mav += sumv
            // console.log('---', s, mav, sumv, sumday);
        }
        return  mav // / madays // 除了值太小
    }
    SUMV(label, period) {
        let value = 0
        for (let m = 0; m < period; m++) {
            value += this.getValue(label, m)
        }
        return  value
    }
    AVGPRC(money, volume) {
        let value = 0
        value = this.getValue(money, 0) / this.getValue(volume, 0)
        return value
    }
}
